function getNodeAuctionsPlusItemTypeByCategory() {
  return {};
}

function getNodeAuctionsPlusItemsByManufacturer() {
  return {};
}

function getBrowserAuctionsPlusItemsByManufacturer() {
  return window.AuctionsPlusItemsByManufacturer || {};
}

function getBrowserAuctionsPlusItemTypeByCategory() {
  return window.AuctionsPlusItemTypeByCategory || {};
}

export function getAuctionsPlusItemTypeByCategory() {
  return typeof window === "undefined"
    ? getNodeAuctionsPlusItemTypeByCategory()
    : getBrowserAuctionsPlusItemTypeByCategory();
}

export function getAuctionsPlusItemsByManufacturer() {
  return typeof window === "undefined"
    ? getNodeAuctionsPlusItemsByManufacturer()
    : getBrowserAuctionsPlusItemsByManufacturer();
}
